<template>
    <div class="mylistwrap" v-if="isload">
        <div v-if="($common.basic.isarrayexist(infolist))" class="mylist">
            <dl class="avg listheader" v-if="!issmall">
                <dd v-if="isteaview">{{$common.dicword('learner')}}</dd>
                <dd>{{$common.dicword('course')}}</dd>
                <dd>{{$common.dicword('topic')}}</dd>
                <dd>{{$common.dicword('lesson')}}</dd>
                <dd>{{$common.dicword('page')}}</dd>
                <dd v-if="isteaview">{{$common.dicword('time')}}</dd>
                <dd v-if="!isteaview">{{$common.dicword('startlearning')}}</dd>
                <dd v-if="!isteaview">{{$common.dicword('learningtime')}}</dd>
            </dl>
            <div class="listinfo">
                <dl class="avg" v-for="item in c_infolist" :key="item.id">
                    <dd v-if="isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learner',true)}}&nbsp;
                        </span><ffmember :username="item.username" :stuid="item.mid"></ffmember>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('course',true)}}&nbsp;
                        </span><router-link class="overparent" :to="'/course/'+item.courseid" :title="$common.langinfo(item.coursetitle,item.coursetitle_en)"><ffoverdot :title="item.coursetitle" :title_en="item.coursetitle_en" :needtitle="false"></ffoverdot></router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('topic',true)}}&nbsp;
                        </span><router-link class="overparent" :to="'/course/'+item.courseid+'/'+item.topicid" :title="$common.langinfo(item.topictitle,item.topictitle_en)"><ffoverdot :title="item.topictitle" :title_en="item.topictitle_en" :needtitle="false"></ffoverdot></router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('lesson',true)}}&nbsp;
                        </span><router-link class="overparent" :to="'/course/'+item.courseid+'/'+item.lessonid" :title="$common.langinfo(item.title,item.title_en)"><ffoverdot :title="item.title" :title_en="item.title_en" :needtitle="false"></ffoverdot></router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('page',true)}}&nbsp;
                        </span><router-link class="overparent" :to="'/course/'+item.courseid+'/'+item.pageid" :title="$common.langinfo(item.pagetitle,item.pagetitle_en)"><ffoverdot :title="item.pagetitle" :title_en="item.pagetitle_en" :needtitle="false"></ffoverdot></router-link>
                    </dd>
                    <dd v-if="isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('time',true)}}&nbsp;
                        </span><span :title="$common.basic.dateformat( item.timebegin,'yyyy-MM-dd hh:mm:ss')+'\n'+$common.basic.dateformat( item.timeend,'yyyy-MM-dd hh:mm:ss')">{{$common.basic.dateformat( item.timebegin,'MM-dd hh:mm')}}</span>
                    </dd>
                    <dd v-if="!isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('startlearning',true)}}&nbsp;
                        </span><span :title="$common.basic.dateformat( item.timebegin,'yyyy-MM-dd hh:mm:ss')">{{$common.basic.dateformat( item.timebegin,'MM-dd hh:mm')}}</span>
                    </dd>
                    <dd v-if="!isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learningtime',true)}}&nbsp;
                        </span>
                        {{$common.basic.chint2timewithsecond(item.remainseconds)}}
                    </dd>
                </dl>
            </div>
            <div class="ffpage">
                <el-pagination :small="issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                </el-pagination>
            </div>
        </div>


        <div class="memnorecord" v-else>{{$common.dicword('norecord')}}</div>
    </div>
</template>

<script>
    import { mixinsubpage } from "@/mixin/mixin"

    export default {
        name: 'Clearning',
        mixins: [mixinsubpage],
        data() {
            return {
                postact: 'tc_mem_learning'
            };
        },
        methods: {
            getdata: function () {
                this.$common.post(this.postjson, res => {
                    this.isload = true;
                    this.infolist = res.infodata;//没有PMP识别，进入课程后再跳转
                    this.res = res;
                });
            }

        }
    }
</script>
